<template>
  <el-container class="content">
    <el-aside class="menu" width="264px">
      <el-menu
          style="width: 100%"
          :key="cateId"
          :default-active="defaultActive"
          class="el-menu-vertical-demo"
          v-if="menuList && menuList.length"
          @select="handleSelect">
        <el-submenu :index="menu.id" v-for="(menu, index) in menuList" :key="index">
          <template slot="title">
            <span>{{ menu.name }}</span>
          </template>
          <template v-if="menu.sub.length">
            <el-submenu :index="subMenu.id" v-for="(subMenu, subIndex) in menu.sub" :key="subIndex">
              <template slot="title">{{subMenu.name}}</template>
              <el-menu-item :index="doc.document_id"
                            v-for="(doc , docIndex) in subMenu.open_document"
                            :key="docIndex">
                {{doc.title}}
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-if="menu.open_document.length">
            <el-menu-item :index="doc.document_id"
                          v-for="(doc , docIndex) in menu.open_document"
                          :key="docIndex">
              {{doc.title}}
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
      <el-empty v-else description="暂无文档" :image-size="50"/>
    </el-aside>
    <el-main class="main">
      <router-view v-if="documentId"></router-view>
      <div v-else>test</div>
    </el-main>
  </el-container>
</template>

<script>
  import apis from "@/api/apis";
export default {
  name: "",
  data(){
    return {
      menuList: [],
      cateId:'',
      documentId: '',
      defaultActive: null
    }
  },
  mounted() {
    this.getMenu()
  },
  methods:{
    getMenu() {
      const params = this.$route.params
      if(!params.cateId){
        return
      }

        apis.document.getOneCateTree({one_cate: params.cateId}).then(res => {
          this.menuList = res.data
          this.cateId = params.cateId
          if(!params.documentId) {
            // 默认打开第一篇文章
            if (this.menuList && this.menuList.length) {
              let documentId = ''
              if (this.menuList[0].open_document && this.menuList[0].open_document.length) {
                documentId = this.menuList[0].open_document[0].document_id
              } else if (this.menuList[0].sub && this.menuList[0].sub.length) {
                if (this.menuList[0].sub[0].open_document && this.menuList[0].sub[0].open_document.length) {
                  documentId = this.menuList[0].sub[0].open_document[0].document_id
                }
              }
              if (documentId) {
                this.defaultActive = documentId
                this.handleSelect(documentId)
              }
            }
          } else {
            this.defaultActive = params.documentId
            this.documentId = params.documentId
          }
        })

    },
    handleSelect(documentId){
      if(documentId){
        this.documentId = documentId
        this.$router.push(`/document/${this.cateId}/article/${documentId}`)
      }
    }
  },
  watch:{
    '$route.params.cateId'(){
      this.getMenu()
    }
  }
}
</script>

<style scoped lang="scss">
  .content{
    width: 1280px;
    margin: auto;
    .menu{
      margin-right: 8px;
      background: #fff;
      ::v-deep.el-menu{
        border-right: none;
      }
    }
  }
</style>
